import { RapidStateCreator } from "../types";

export interface UserSliceState {
    user: { uid: string; email?: string | null; displayName?: string | null } | null;

    // Setter
    setUser: (user: UserSliceState["user"]) => void;
}

export const createUserSlice: RapidStateCreator<UserSliceState> = (set) => ({
    // Initial state
    user: null,

    // Actions
    setUser: (user) => set({ user }, false, "setUser")
});
